class CompVideo extends HTMLElement {
  constructor() {
    super();

    this.videos = [...this.querySelectorAll('video')];

    this.btn = this.querySelector('[data-toggle-video]');
  }

  connectedCallback() {
    if (this.videos && this.btn) {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleVideo();
      })
    }
  }

  toggleVideo() {
    if (this.btn.classList.contains('playing')) {
      this.videos.map(video => video.pause());
      this.btn.classList.remove('playing');
    } else {
      this.videos.map(video => video.play());
      this.btn.classList.add('playing');
    }
  }
}

if (!customElements.get("comp-video")) {
  customElements.define("comp-video", CompVideo);
}
